module.exports = "https://static.futunn.com/components/common-offline-activity-ticket/images/ticket-bg.ac00e529dc.png";